module.exports = __webpack_public_path__ + "img/20200616_152234.debafbde.jpg";